module.exports = __webpack_public_path__ + "img/translate.8cf84ba4.png";